// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2tvtd","rightAdornment":"Header_rightAdornment__2M62i"};